import { restRequest } from "vrcore-dashboard/dist/utilities.js";
export const SUBMIT_SSWP_CONFIG = restRequest("SUBMIT_SSWP_CONFIGURATION");
export const GET_MASTER_SSWP_CONFIGURATIONS = restRequest("GET_MASTER_SSWP_CONFIGURATIONS");
export const DELETE_SSWP_CONFIG = restRequest("DELETE_SSWP_CONFIGURATION");
